import React from 'react'

import { Body1, Box, Color, Heading4, Image, TextAlign } from '@gousto-internal/citrus-react'
import type { RootStateOrAny } from 'react-redux'
import { useDispatch, useSelector } from 'react-redux'

import { DeviceType, useDeviceType } from '@library/dom'

import { menuPreferencesVisibilityChange } from 'actions/menu'
import { incrementTutorialViewed, tutorialTracking } from 'actions/tutorial'
import { Portal } from 'routes/Menu/components/Portal'
import { Step, Tutorial } from 'routes/Menu/components/Tutorial'
import { useCustomisedRecipeTiles } from 'routes/Menu/hooks/useCustomisedRecipeTiles'

import menuPreferencesSpotlightImage from 'media/photos/menu-preferences-spotlight.jpg'

import { useShowJFYTutorial } from '../JustForYouTutorial/useShowJFYTutorial'

const tutorialName = 'menu_preferences'

export const MenuPreferencesTutorial = () => {
  const dispatch = useDispatch()
  const deviceType = useDeviceType()
  const showCFYTutorial = useShowJFYTutorial()
  const isCustomisedRecipeTilesEnabled = useCustomisedRecipeTiles()

  const tutorialViewed = useSelector(({ tutorial }: RootStateOrAny) =>
    Boolean(tutorial && tutorial.getIn(['viewed', tutorialName])),
  )

  const openSidebar = () => {
    dispatch(menuPreferencesVisibilityChange(true))
  }

  const onCloseTutorial = (step: number) => {
    dispatch(incrementTutorialViewed(tutorialName))
    dispatch(tutorialTracking(tutorialName, step, true))
  }

  const trackStepViewed = (step: number) => {
    dispatch(tutorialTracking(tutorialName, step, false))
  }

  if (tutorialViewed || showCFYTutorial) {
    return null
  }

  const tutorialContent = isCustomisedRecipeTilesEnabled
    ? {
        heading: 'Edit the information you see',
        body: 'See what matters most at a glance',
        imageAlt: 'Recipe information preferences',
      }
    : {
        heading: 'Personalise your menu',
        body: "Set your preferences and we'll let you know if any recipes are less relevant for you.",
        imageAlt: 'Calories education',
      }

  return (
    <Portal>
      <Tutorial onClose={onCloseTutorial} trackStepViewed={trackStepViewed}>
        <Step
          buttonText="Set preferences"
          next={openSidebar}
          selector={`[data-testid="menu-preferences-button-${
            deviceType === DeviceType.DESKTOP ? 'desktop' : 'mobile'
          }"]`}
        >
          <Box paddingH={3}>
            <Box maxWidth="380px" paddingBottom={4}>
              <Image alt={tutorialContent.imageAlt} src={menuPreferencesSpotlightImage} />
            </Box>
            <Heading4 color={Color.Primary_600} textAlign={TextAlign.Center}>
              {tutorialContent.heading}
            </Heading4>
            <Body1 textAlign={TextAlign.Center}>{tutorialContent.body}</Body1>
          </Box>
        </Step>
      </Tutorial>
    </Portal>
  )
}
